import { gql } from "@apollo/client";

export default gql`
  fragment AssessmentQuestionFragment on AssessmentQuestionInterface {
    ... on OverallGoalAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on OverallRecognitionCoreValueAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on IndividualGoalAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on IndividualRecognitionCoreValueAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on RangeAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on CompetencyAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on CompetencyCriteriaAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on ResponsibilityAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on TalentIndicatorAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      startValue
      endValue
      labels
      labelDescriptions
    }
    ... on TextAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
    }
    ... on NpsAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
    }
    ... on MultiChoiceAssessmentQuestionNode {
      id
      title
      description
      archived
      answersExist
      comment
      responses
      responseVisibility
      questionType
      created
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      categories {
        edges {
          node {
            id
            title
          }
        }
      }
      creator {
        id
        name
      }
      options
      optionDescriptions
    }
  }
`;
